import { render, staticRenderFns } from "./DimensionsHelp.vue?vue&type=template&id=9ce79334"
import script from "./DimensionsHelp.vue?vue&type=script&lang=js"
export * from "./DimensionsHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports